export const BASE_URL = "https://multipla-api.multiplasistemas.com.br/api/"